var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.405 4.228a15.548 15.548 0 01-4.459 1.222 7.783 7.783 0 003.414-4.297 15.5 15.5 0 01-4.93 1.883A7.767 7.767 0 0019.2 10.12 22.048 22.048 0 013.196 2.006a7.76 7.76 0 00-1.05 3.904A7.767 7.767 0 005.6 12.373a7.746 7.746 0 01-3.517-.972v.1a7.767 7.767 0 006.228 7.614 7.822 7.822 0 01-3.506.133 7.769 7.769 0 007.253 5.39 15.58 15.58 0 01-9.643 3.325c-.62 0-1.239-.036-1.854-.108a21.958 21.958 0 0011.9 3.488c14.284 0 22.092-11.83 22.092-22.09 0-.333-.008-.67-.023-1.003A15.784 15.784 0 0038.4 4.233l.004-.005z",
    fill: "#fff"
  })));
}
export default SvgTwitterWhite;